import { ThemeProvider } from "@emotion/react";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { Box, Typography } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import BigNormalButton from "components/atoms/Button/BigNormalButton";
import RoadmapCards from "components/molecules/Card/RoadMapCards";
import * as React from "react";
import useStyles from "./Body.styles";

const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
    secondary: {
      main: "#36899f",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const MuiBlueLine= withStyles({
  root: {
    paddingRight:"0px !important",
    "& .MuiTimeline-root": {
      paddingRight:"0px !important",
    }
  },
})(Timeline);

const MuiBlueLineItem = withStyles({
  root: {
    "&:before": {
      display: "contents",
    },
    "& .MuiTimelineDot-root": {
      backgroundColor: "#31ad49",
      top: "80px",
      position: "absolute",
      left: "-5px",
    },
    "& .MuiTimelineConnector-root": {
      backgroundColor: "#31ad49",
    },
    missingOppositeContent: {
      "&:before": {
        display: "none",
      },
    },
  },
})(TimelineItem);

const MuiYellowLineItem = withStyles({
  root: {
    "&:before": {
      display: "contents",
    },
    "& .MuiTimelineDot-root": {
      backgroundColor: "#ddb930",
      top: "80px",
      position: "absolute",
      left: "-5px",
    },
    "& .MuiTimelineConnector-root": {
      backgroundColor: "#ddb930",
    },
    missingOppositeContent: {
      "&:before": {
        display: "none",
      },
    },
  },
})(TimelineItem);

const RoadmapBody = () => {
  const classes = useStyles();
  const howIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 25.231 22.878"
    >
      <g
        id="Icon_feather-pocket"
        data-name="Icon feather-pocket"
        transform="translate(-2.15 -3.65)"
      >
        <path
          id="Path_477"
          data-name="Path 477"
          d="M5.353,4.5H24.178a2.353,2.353,0,0,1,2.353,2.353v7.059A11.766,11.766,0,1,1,3,13.913V6.853A2.353,2.353,0,0,1,5.353,4.5Z"
          transform="translate(0)"
          fill="none"
          stroke="#36899f"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
        <path
          id="Path_478"
          data-name="Path 478"
          d="M12,15l4.706,4.706L21.413,15"
          transform="translate(-1.941 -2.264)"
          fill="none"
          stroke="#36899f"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
      </g>
    </svg>
  );

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box className={classes.body}>
          <Typography
            className={classes.headertitleText}
            style={{ marginBottom: "30px" }}
          >
            White Paper & Roadmap
          </Typography>
          <Typography
            className={classes.titleText}
            style={{ marginBottom: "21px" }}
          >
            White Paper
          </Typography>
          <Typography
            className={classes.weakDescriptionText}
            style={{ marginBottom: "30px" }}
          >
            Placeholder text for white paper: Lorem ipsum dolor sit amet,
            consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullamco laboris nisi ut aliquip ex ea commodo c
          </Typography>
          <Box style={{ height: "65px", marginBottom: "40px" }}>
            <BigNormalButton color={"yellow"} text={"View WhitePaper"} />
          </Box>
          <Box style={{ height: "50px", width: "150px", marginBottom: "15px" }}>
            <BigNormalButton color={"normal"} text={"🌟 BUKU BUCKS"} />
          </Box>
          <Typography
            className={classes.titleText}
            style={{ marginBottom: "20px" }}
          >
            How tokenomics work?
          </Typography>
          <Typography
            className={classes.strongDescriptionText}
            style={{ marginBottom: "30px" }}
          >
            Buku Bucks is a coin focused on community funding creators. Not only
            through collecting NFTs, but by trading our coin as well. 10% is
            taken after every transaction for the following.
          </Typography>
          <Box className={classes.howSection}>
            <Box className={classes.howLeftSection}>{howIcon}</Box>
            <Box className={classes.howRightSection}>
              <Typography className={classes.howTitleText}>
                Developer Wallet
              </Typography>
              <Typography className={classes.howDesText}>
                5% of transactions fees are moved into developer wallet (locked
                for 6 months!)
              </Typography>
            </Box>
          </Box>
          <Box className={classes.howSection}>
            <Box className={classes.howLeftSection}>{howIcon}</Box>
            <Box className={classes.howRightSection}>
              <Typography className={classes.howTitleText}>
                Creator Fund
              </Typography>
              <Typography className={classes.howDesText}>
                4% of transaction fees are moved to creator fund
              </Typography>
            </Box>
          </Box>
          <Box className={classes.howSection}>
            <Box className={classes.howLeftSection}>{howIcon}</Box>
            <Box className={classes.howRightSection}>
              <Typography className={classes.howTitleText}>Burned</Typography>
              <Typography className={classes.howDesText}>
                1% of tokens are burned with transaction
              </Typography>
            </Box>
          </Box>

          <Typography
            className={classes.headertitleText}
            style={{ marginTop: "40px" }}
          >
            💫 Roadmap
          </Typography>

          <MuiBlueLine>
            <MuiBlueLineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {
                  <RoadmapCards
                    type={"blue"}
                    title={"MORE INFORMATION SOON..."}
                    icon={"refresh"}
                    name={"Jone Dev"}
                    role={"React"}
                    description={
                      "A functionality that will change the way users interact on Buku 💫"
                    }
                    protitle={"Early development"}
                    pronum={30}
                    date={"September 3rd, 2021"}
                    active={false}
                  />
                }
              </TimelineContent>
            </MuiBlueLineItem>
            <MuiBlueLineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {" "}
                {
                  <RoadmapCards
                    type={"blue"}
                    title={"EXAMPLE PROJECT"}
                    icon={"setting"}
                    name={"Jone Dev"}
                    role={"React"}
                    description={
                      "A functionality that will change the way users interact on Buku 💫"
                    }
                    protitle={"Early development"}
                    pronum={30}
                    date={"September 3rd, 2021"}
                    active={true}
                  />
                }
              </TimelineContent>
            </MuiBlueLineItem>
            <MuiBlueLineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {" "}
                {
                  <RoadmapCards
                    type={"blue"}
                    title={"EXAMPLE PROJECT"}
                    icon={"setting"}
                    name={"Jone Dev"}
                    role={"React"}
                    description={
                      "A functionality that will change the way users interact on Buku 💫"
                    }
                    protitle={"Early development"}
                    pronum={30}
                    date={"September 3rd, 2021"}
                    active={true}
                  />
                }
              </TimelineContent>
            </MuiBlueLineItem>
            <MuiYellowLineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {
                  <RoadmapCards
                    type={"yellow"}
                    title={"PROJECT 25 (COMPLETED)"}
                    icon={"refresh"}
                    name={"Jone Dev"}
                    role={"React"}
                    description={
                      "A functionality that will change the way users interact on Buku 💫"
                    }
                    protitle={"Early development"}
                    pronum={30}
                    date={"September 3rd, 2021"}
                    active={true}
                  />
                }
              </TimelineContent>
            </MuiYellowLineItem>
            <MuiYellowLineItem>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {" "}
                {
                  <RoadmapCards
                    type={"yellow"}
                    title={"PROJECT 25 (COMPLETED)"}
                    icon={""}
                    name={"Jone Dev"}
                    role={"React"}
                    description={
                      "A functionality that will change the way users interact on Buku 💫"
                    }
                    protitle={"Early development"}
                    pronum={30}
                    date={"September 3rd, 2021"}
                    active={true}
                  />
                }
              </TimelineContent>
            </MuiYellowLineItem>
            <MuiYellowLineItem>
              <TimelineSeparator sx={{width:"3px"}}>
                <TimelineDot />
                <TimelineConnector sx={{position:"relative",left:"-1px"}}/>
                <ArrowDownwardIcon sx={{position:"relative",left:"-1px",top:"-4px",color:"#ddb930"}}/>
              </TimelineSeparator>
              <TimelineContent>
                {" "}
                {
                  <RoadmapCards
                    type={"yellow"}
                    title={"MORE INFORMATION SOON..."}
                    icon={"wifi"}
                    name={"Jone Dev"}
                    role={"React"}
                    description={
                      "A functionality that will change the way users interact on Buku 💫"
                    }
                    protitle={"Early development"}
                    pronum={30}
                    date={"September 3rd, 2021"}
                    active={true}
                  />
                }
              </TimelineContent>
            </MuiYellowLineItem>
          </MuiBlueLine>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default RoadmapBody;
